// import PanelSnap from 'panelsnap';
// let archPanel = null;

export default {
	namespace: 'artchitecture',
	beforeEnter(barba) {

		barba.next.container.querySelector('ul.nav').classList.add('fixed-nav');

	},
	afterEnter(barba) {
		
		barba.next.container.querySelector('ul.nav').classList.add('fixed-nav');

		// let pSnapContainer = barba.next.container.querySelector('.artchitecture-wrapper')

		// console.log(pSnapContainer)

		// var defaultOptions = {
		// 	// container: pSnapContainer,
		// 	panelSelector: '.artchitecure-item',
		// 	directionThreshold: 500,
		// 	delay: 0,
		// 	duration: 300,
		// 	easing: function(t) { return t }
		// };

		// archPanel = new PanelSnap(defaultOptions);

		// archPanel.on('activatePanel', function(panel) {
		// 	var currentActivePanel = document.querySelector('.artchitecure-item.active');

		// 	if (currentActivePanel) {
		// 		currentActivePanel.classList.remove('active');
		// 	}

		// 	panel.classList.add('active');
		// });

	},
	beforeLeave(barba) {

		// archPanel.destroy();
		barba.next.container.querySelector('ul.nav').classList.remove('fixed-nav');

	},
	afterLeave() {

	}
}
